import React from 'react'
import { Helmet } from 'react-helmet-async'
import { useLocation } from 'react-router-dom'

import { useSSRAppleBannerContext } from 'src/server/SSRAppleBannerContext'

import { noIndex as noIndexConfig, resources } from 'config'
import { t } from 'src/translations'

const ToastLocalHelmet = () => {
  const location = useLocation()
  const { appleSmartBannerContent } = useSSRAppleBannerContext()
  const url = `https://${resources.toastLocalHost}${location.pathname}`
  const title = t('toast-local-helmet.the-best-food')
  const description = t('toast-local-helmet.best-place')
  const logoSrc =
    'https://cdn.toasttab.com/static/42fd6cabe2aa1dc8ad50e0d66f30ce9e3de4aa36/images/favicon.ico'
  const noIndex = noIndexConfig

  return (
    <Helmet>
      {noIndex ? <meta name='robots' content='noindex, nofollow' /> : null}
      <meta name='description' content={description} />
      <meta property='og:description' content={description} />
      <link rel='canonical' href={url} />
      <meta property='og:url' content={url} />
      <meta property='og:type' content='website' />
      <meta property='og:site_name' content='Toast Local' />
      <title>{title}</title>
      <meta property='og:title' content={title} />
      <link rel='icon' id='favicon' href={logoSrc} />
      <link
        href='https://fonts.googleapis.com/css2?family=Source+Sans+Pro:wght@400;600;700&display=swap'
        rel='stylesheet'
      />
      {appleSmartBannerContent && (
        <meta name='apple-itunes-app' content={appleSmartBannerContent} />
      )}
    </Helmet>
  )
}

export default ToastLocalHelmet
